/** Partituras bundled en public/bordona/starter — sin subir MusicXML. */
export interface StarterSong {
  id: string;
  title: string;
  artist: string;
  assetPath: string;
  tempo?: number;
  description?: string;
}

export const STARTER_SONGS: StarterSong[] = [
  {
    id: "starter-estrellita",
    title: "Estrellita",
    artist: "Melodía tradicional",
    assetPath: "/bordona/starter/estrellita.musicxml.xml",
    tempo: 72,
    description:
      "Tu primera melodía: ocho compases en Do mayor, ideal para practicar en modo Aprender.",
  },
];

export function getStarterSongById(id: string | undefined): StarterSong | undefined {
  if (!id) return undefined;
  return STARTER_SONGS.find((s) => s.id === id);
}

export function isStarterSongId(id: string | undefined): boolean {
  return Boolean(getStarterSongById(id));
}
